export default __webpack_public_path__ + "static/media/img_8.ac0da40a.JPG";